import { transformDateValue } from 'core/js/FormUtils';
export const getStockoutreqView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stockoutreqList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Initiated By","fieldValue":transformDataValue(data.initiatedby,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stockoutreqList.push(card);
  })
  return stockoutreqList;
}